import { APIRequest } from "./ApiResponse"

export enum COMPANY_STATUS {
  CHURNED = -1,
  TRIAL = 0,
  CUSTOMER = 1,
  KAMAE = 2,
  STARTER = 3,
}

export enum LOGIN_METHOD {
  SSO = "SSO",
  MAGIC_LINK = "MAGIC_LINK",
  PASSWORD = "PASSWORD",
}

export enum DEFAULT_LANGUAGE {
  FR = 1,
  EN = 2,
  ES = 3,
  DE = 4,
  PT = 5,
  IT = 6,
}

export const LANGUAGE_MAP: Record<DEFAULT_LANGUAGE, string> = {
  [DEFAULT_LANGUAGE.FR]: "fr",
  [DEFAULT_LANGUAGE.EN]: "en",
  [DEFAULT_LANGUAGE.ES]: "es",
  [DEFAULT_LANGUAGE.DE]: "de",
  [DEFAULT_LANGUAGE.PT]: "pt",
  [DEFAULT_LANGUAGE.IT]: "it",
} as const

export enum TEAMS_MANAGED_BY {
  DIR_SYNC = "DIR_SYNC",
  MANUAL = "MANUAL",
  UNSPECIFIED = "UNSPECIFIED",
}

export enum LICENSE_ENDING_STATUS {
  INFO = "INFO",
  WARNING = "WARNING",
  CRITICAL = "CRITICAL",
}

export interface Company extends APIRequest {
  id: number
  name: string
  level: number
  progress: number
  creation: Date
  status: COMPANY_STATUS
  logo: string
  global_score?: number
  total_user?: number
  idp?: string
  loginMethod?: LOGIN_METHOD
  phishing_enabled: boolean
  sso_enabled: boolean
  lms_enabled: boolean
  license_start_date?: Date
  license_end_date?: Date
  max_users?: number
  max_admins?: number
  onboarding_completed?: boolean
  defaultLanguageId: DEFAULT_LANGUAGE
  dir_sync_enabled: boolean
  dir_sync_activated?: boolean
  license_days_left?: number
  license_ending_status?: LICENSE_ENDING_STATUS
  automated_phishing_activated: boolean
  external_customer_id?: string
  teams_managed_by?: TEAMS_MANAGED_BY
  is_phishing_report_button_active?: boolean
  hide_rankings: boolean
}
